import Snackbar from "@mui/material/Snackbar";
import Tooltip from "@mui/material/Tooltip";

// "#4CAF50"

const NitroPopup = ({
  children,
  color,
  open,
  close,
  tooltip,
}: {
  children: React.ReactElement | React.ReactElement[] | string;
  color: "success" | "error";
  open: boolean;
  close: () => void;
  tooltip?: string;
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={close}
      ContentProps={{
        style: {
          backgroundColor: color === "success" ? "#4CAF50" : "#C52F00",
          color: "white",
          fontWeight: 400,
          fontSize: 14,
          borderRadius: 10,
          padding: "10px 20px",
          top: 0,
          right: 0,
          zIndex: 140,
        },
      }}
      message={
        <Tooltip title={tooltip || ""} placement="top-start">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            {children}
          </div>
        </Tooltip>
      }
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    />
  );
};

export default NitroPopup;
